export default Object.freeze({
  STYLE_QUIZ_TITLE: "Style Quiz (2023) Final",
  STYLE_QUIZ_FORM_ID: "I0vArEdB",
  PROD_FEEDBACK_SURVEY_TITLE: "Simple Product Feedback Form Aug23",
  PROD_FEEDBACK_SURVEY_FORM_ID: "hDzYk1sB",
});
